import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
} from "react-router-dom";
import Hero from "../views/Landing/Landing";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const AppRouter = () => {
  return (
    <Router>
      <div className="bg-gray-100">
<Navbar />
        {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
        <Switch>
          <Route exact path="/">
            <Hero />
          </Route>
        </Switch>        
        <Footer />
      </div>
    </Router>
  );
};
export default AppRouter;
